export default {
	title: "Entrar como Miembro",
	enterCode: "Introduzca el código de invitación que ha recibido",
	code: "Código de Invitación",
	validate: "Validar Código",
	invalidCode: "Código inválido o caducado",
	createAccount: "Crear su Cuenta",
	joiningTemple: "Está entrando en el templo: {temple}",
	invitedTo: "Ha sido invitado a este templo",
	displayName: "Nombre Completo",
	ritualFunction: "Función en el Templo",
	ritualFunctionHint: "Ej: Médium, Cambono, Ogã (opcional)",
	submit: "Crear Cuenta",
	acceptInvite: "Aceptar Invitación",
	acceptAndJoin: "Aceptar y Entrar al Templo",
	loggedInAs: "Ha iniciado sesión como {name} ({email})",
	error: "Error al crear cuenta. Inténtelo de nuevo.",
};
